/* istanbul ignore file */

import { defineMessages } from 'react-intl';

import { NotificationCategoryType } from '@sg/shared/features/notifications';

// ─────────────────────────────────────────────────────────────────────

export const messages = defineMessages({
  title: {
    defaultMessage: 'Notifications',
    description: 'Notifications | Title',
  },
  pushNotificationsLabel: {
    defaultMessage: 'Push Notifications',
    description: 'Notifications | Push Notifications',
  },
  emailLabel: {
    defaultMessage: 'Email',
    description: 'Notifications | Email',
  },
  pushDisabledNotice: {
    defaultMessage:
      'Turn on push notifications from your device settings to see notifications from sweetgreen',
    description: 'Notifications | Push Notification | Disabled Text',
  },
  goToDeviceSettings: {
    defaultMessage: 'Go to device settings',
    description: 'Notifications | Push Notification | Action Text',
  },
  preferencesUpdateFailure: {
    defaultMessage: 'We couldn’t save your preferences. Please try again in a moment.',
    description: 'Notifications | Update Error Text',
  },
  tryAgain: {
    defaultMessage: 'Try again',
    description: 'Notifications | Update Error | Refetch button text',
  },
  unresolvedCategoryMessage: {
    defaultMessage:
      "We are currently unable to retrieve your settings for {category}. Don't worry - your settings haven't changed. Please check again in a few moments.",
    description: 'Notifications | Category Unresolved Message',
  },
});

export const categoryMessages: Record<
  NotificationCategoryType,
  ReturnType<typeof defineMessages>
> = {
  [NotificationCategoryType.OrderStatus]: defineMessages<CategoryMessageKey>({
    title: {
      defaultMessage: 'Order Updates',
      description: 'Notifications | Order Updates | Title',
    },
    subtitle: {
      defaultMessage: 'Stay updated on the status of your order',
      description: 'Notifications | Order Updates | Subtitle',
    },
  }),
  [NotificationCategoryType.Marketing]: defineMessages<CategoryMessageKey>({
    title: {
      defaultMessage: 'Sweetgreen offers',
      description: 'Notifications | Sweetgreen offers | Title',
    },
    subtitle: {
      defaultMessage: 'Choose how to get special offers, promos, and personalized suggestions',
      description: 'Notifications | Sweetgreen offers | Subtitle',
    },
  }),
};

// ─── Types ───────────────────────────────────────────────────────────

type CategoryMessageKey = 'title' | 'subtitle';
